import type { IconData } from '@stacksjs/iconify-core'

export const clockTen: IconData = {
  "body": "<circle cx=\"12\" cy=\"12\" r=\"10\" fill=\"currentColor\" opacity=\".5\"/><path fill=\"currentColor\" d=\"M13 7a1 1 0 0 0-2 0v3.268l-1.098-.634a1 1 0 0 0-1 1.732l2.598 1.5A1.014 1.014 0 0 0 13 12Z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default clockTen
